import { useShouldShowIAFeature } from 'hooks/IAFeaturesHook';
export const useShouldShowAutoRating = () => useShouldShowIAFeature('ai_auto_rating');
